import classNames from 'clsx';
const getPaddingClassNames = map => {
  const {
    top,
    right,
    bottom,
    left,
    horizontal,
    vertical,
    all
  } = map;
  return classNames(typeof top === 'number' && `Padding-top--${top}`, typeof right === 'number' && `Padding-right--${right}`, typeof bottom === 'number' && `Padding-bottom--${bottom}`, typeof left === 'number' && `Padding-left--${left}`, typeof horizontal === 'number' && `Padding-horizontal--${horizontal}`, typeof vertical === 'number' && `Padding-vertical--${vertical}`, typeof all === 'number' && `Padding-all--${all}`);
};
export default getPaddingClassNames;